module.exports = __webpack_public_path__ + "static/media/traffic-event.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/traffic-event.svg
// module id = 866
// module chunks = 0